uvex-product-related-articles-slider {
  display: block;
  position: relative;
}
